import { render } from "./NewNovaApp.vue?vue&type=template&id=e409be22"
import script from "./NewNovaApp.vue?vue&type=script&lang=js"
export * from "./NewNovaApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__